/* eslint-disable angular/controller-as */
angular.
module("dx.webapp.node").
controller("DxIconPickerController", function IconPickerController(
	$scope,

	dxDialog,
	DX_EXTERNAL_TOOL_ICON_IDENTIFIER
) {
	"use strict";

	var self = this;

	self.iconList = DX_EXTERNAL_TOOL_ICON_IDENTIFIER;

	self.previewIcon = $scope.toolIcon;

	self.onClickIcon = function onClickIcon(iconId) {
		self.previewIcon = iconId;
	};

	self.done = function done() {
		$scope.setIcon(self.previewIcon);
		dxDialog.closeMostRecent();
	};
	self.cancel = function cancel() {
		dxDialog.closeMostRecent();
	};
});
